import PropTypes from "prop-types";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import PaymentContact from "app/pages/Booking/Payment/PaymentContact";
import { getProfile as getProfileAction } from "app/pages/Account/Profile/profileActionCreators";
import { PROFILE_CODE_STATUS } from "app/constants";
import withRouter from "app/utils/hocs/withRouter";
import { getCurrentShop } from "app/reducers/shopSelector";
import { shouldGetProfileAtPayment } from "app/pages/Account/Profile/profileSelector";
import usePrevious from "app/utils/hooks/usePrevious";
import { useCallback, useEffect } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { getCredentials } from "app/utils/auth";
import { isOperatorMode } from "app/pages/Auth/authSelectors";

const mapStateToProps = state => {
	const { token } = getCredentials();
	const email = state.email;

	const isOperator = isOperatorMode(state);

	return {
		strategy: state.partner.strategy,
		token: token,
		shop: getCurrentShop(state),
		isLoading: state.profile.status === PROFILE_CODE_STATUS.LOADING,
		shouldDisableEmailField: shouldGetProfileAtPayment() && email && !isOperator,
		shouldFetchProfile: shouldGetProfileAtPayment(),
		confidentialiteDocumentName: state.documents.confidentialite,
	};
};

const PaymentContactContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const getProfile = useCallback(() => dispatch(getProfileAction()), [dispatch]);

	const { token } = stateProps;
	const { shouldGetProfileAtPayment } = props;

	const { track } = useAnalytics();

	const prevToken = usePrevious(token);

	const fetchProfile = useCallback(() => {
		if (shouldGetProfileAtPayment) {
			getProfile()
				.then(() => {
					// on doit absolument récupérer les crédits après un getProfile
					// car le back end met à jour les crédits lors du getProfile
					track("payment_fetch_profile_success");
				})
				.catch(() => {
					track("payment_fetch_profile_failed");
				});
		}
	}, [shouldGetProfileAtPayment]);

	useEffect(() => {
		fetchProfile();
	}, []);

	useEffect(() => {
		if (prevToken && token && prevToken !== token) {
			fetchProfile();
		}
	}, [token, prevToken]);

	return <PaymentContact {...props} {...stateProps} getProfile={getProfile} />;
};

PaymentContactContainer.propTypes = {
	getProfile: PropTypes.func,
	token: PropTypes.string,
	shouldGetProfileAtPayment: PropTypes.bool,
};

export default withRouter(PaymentContactContainer);
